import { Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTestCredential } from '@/hooks/useCredentials';

interface Props {
  credentialId: string;
}

export function CredentialTestButton({ credentialId }: Props) {
  const { mutate: test, isPending } = useTestCredential();

  return (
    <Button
      variant="outline"
      size="sm"
      disabled={isPending}
      onClick={() => test(credentialId)}
    >
      <Zap className="h-3 w-3" />
      {isPending ? 'Testando…' : 'Testar'}
    </Button>
  );
}
